const businessEntity = {
  id: null,
  businessEntityName: null,
  createdBy: null,
  updatedBy: null
}

export default () => Object.assign({}, businessEntity)
